/* Progressive enhancement: all product information remains readable without JS. */
if (!customElements.get('bf-product-details')) {
  customElements.define('bf-product-details', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      const list = this.querySelector('.bf-details__tabs');
      const tabs = Array.from(list.querySelectorAll('button'));
      const panels = Array.from(this.querySelectorAll('.bf-details__panel'));
      if (!tabs.length || tabs.length !== panels.length) return;
      list.setAttribute('role', 'tablist');
      const activate = (index, focus = false) => {
        tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
          panels[i].hidden = i !== index;
        });
        if (focus) tabs[index].focus({ preventScroll: true });
      };
      tabs.forEach((tab, i) => {
        tab.setAttribute('role', 'tab');
        panels[i].setAttribute('role', 'tabpanel');
        panels[i].setAttribute('aria-labelledby', tab.id);
        panels[i].tabIndex = 0;
        tab.addEventListener('click', () => activate(i));
        tab.addEventListener('keydown', event => {
          let next = i;
          if (event.key === 'ArrowRight') next = (i + 1) % tabs.length;
          else if (event.key === 'ArrowLeft') next = (i - 1 + tabs.length) % tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = tabs.length - 1;
          else return;
          event.preventDefault();
          activate(next, true);
        });
      });
      this.addEventListener('shopify:block:select', event => {
        const index = panels.findIndex(panel => panel.contains(event.target));
        if (index !== -1) activate(index);
      });
      activate(0);
      list.hidden = false;
      this.classList.add('is-enhanced');
    }
  });
}
